var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({staticClass:"generic-button",style:(_vm.customStyle),attrs:{"disabled":_vm.buttonDisabled,"loading":_vm.loading},on:{"click":_vm.runAction}},'v-btn',{..._vm.button},false),[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }